var map = {
	"./airplane.svg": "1ac1",
	"./angle-down.svg": "7745",
	"./angle-left.svg": "588c",
	"./angle-right.svg": "9a98",
	"./arrow-left.svg": "c29e",
	"./back.svg": "b069",
	"./bell.svg": "9833",
	"./bookmark.svg": "3b56",
	"./burger.svg": "a335",
	"./calendar.svg": "c94b",
	"./circle-minus.svg": "da2e",
	"./circle-plus.svg": "e409",
	"./clock.svg": "b86b",
	"./close.svg": "3b45",
	"./comments.svg": "3ad6",
	"./crown.svg": "b912",
	"./d-plius.svg": "50c8",
	"./door.svg": "50d6",
	"./envelope.svg": "0993",
	"./forecast-cloud.svg": "e334",
	"./gallery-border.svg": "fb40",
	"./gallery.svg": "9f13",
	"./group.svg": "0d5e",
	"./home.svg": "39cd",
	"./info-circle.svg": "c4d2",
	"./issue-toc.svg": "563d",
	"./link.svg": "2871",
	"./listen.svg": "019e",
	"./live.svg": "3fd8",
	"./microphone.svg": "1c47",
	"./mobile.svg": "f970",
	"./most-bought.svg": "2b3e",
	"./pc.svg": "47f3",
	"./play.svg": "ca51",
	"./print.svg": "826a",
	"./question-bubble.svg": "9913",
	"./saugu.svg": "af52",
	"./search.svg": "0867",
	"./share.svg": "474b",
	"./social-envelope.svg": "7943",
	"./social-facebook-circle.svg": "0524",
	"./social-facebook.svg": "b042",
	"./social-instagram.svg": "d7fd",
	"./social-linkedin.svg": "4d7e",
	"./social-messenger.svg": "326d",
	"./social-twitter.svg": "b861",
	"./social-vk.svg": "a0aa",
	"./success.svg": "b059",
	"./text-size.svg": "0331",
	"./total-package.svg": "b40b",
	"./trash.svg": "9e99",
	"./trending.svg": "27cd",
	"./user-picture.svg": "0245",
	"./user.svg": "a527",
	"./warning.svg": "805a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc8c";